import { getCookie } from 'sutils';

const getMeetingEnv = () => {
    const envName = getCookie('env_name');
    if (!envName || /^release/.test(envName)) {
        return 'release';
    }
    if (/prerelease/.test(envName)) {
        return 'prerelease';
    }
    return 'test';
};

const getMeetingParams = () => {
    const meetingEnv = getMeetingEnv();
    const meetingParamsMap = {
        test: {
            sdkId: '16282553643',
            corpId: '200008554',
        },
        prerelease: {
            sdkId: '16310196082',
            corpId: '1400212767',
        },
        release: {
            sdkId: '16272901304',
            corpId: '1400115281',
        },
    };
    return meetingParamsMap[meetingEnv];
};

export const initWemeetAgentConfig = async () => {
    const { sdkId, corpId } = getMeetingParams();
    const { default: MeetingHelper } = await import(/* webpackChunkName: "tencent-meeting" */ '@tencent/docs-scenario-components-meeting-helper');
    const meetingHelper = MeetingHelper.getInstance({ sdkId, corpId });
    const isInited = await meetingHelper.checkJsApiConfig();
    if (!isInited) {
        await meetingHelper.init();
    }
};
